import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api"



import Header from "./content/header"

class RemoveAlunoAdm extends Component {


 
state ={
  nome:null,
  cpf:null,
  email:null,
  telefone1:null,
  telefone2:null,
  iduser:this.props.match.params.iduser,
  aluno:[]
}

async componentDidMount(){
 

  const {iduser} = this.state;
  const response = await api.post("admin/user/id", {iduser});

  this.setState({
    aluno:response.data.success,
    nome:response.data.success.nomecompleto,
  cpf:response.data.success.cpf,
  telefone1:response.data.success.telefone1,
  telefone2:response.data.success.telefone2,
  email:response.data.success.user.email
  })

  



}



















    rmaluno = async e => {
    e.preventDefault();
    const { iduser} = this.state;
      if (!iduser) {
          this.setState({ error: "Preencha os dados antes de excluir!",
        success:null });
          
      } else {
      const { iduser } = this.state;
      const response = await api.post("/admin/user/del", { iduser });

        if(response.data.success.deleted_at){
         
          this.props.history.goBack();
        }

      }
  }


  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <h4>Deletar Usuário</h4>     
        <form onSubmit={this.rmaluno}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

        <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" defaultValue={this.state.nome} onChange={e => this.setState({ nome: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail</label>
                    <input type="text" class="form-control" defaultValue={this.state.email} onChange={e => this.setState({ email: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">CPF</label>
                    <input type="text" class="form-control" defaultValue={this.state.cpf} onChange={e => this.setState({ cpf: e.target.value })}  />
                </div>
                <div class="form-group">
                <button class="btn btn-danger mb-2">Remover Matricula</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(RemoveAlunoAdm);


// WEBPACK FOOTER //
// ./src/pages/Admin/removealuno.js